import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DetailActivityDatePipe } from './detail-activity-date.pipe';

@Component({
  selector: 'sim-detail-activity',
  imports: [DetailActivityDatePipe],
  templateUrl: './detail-activity.component.html',
  styleUrl: './detail-activity.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'detail-activity'
  }
})
export class SimDetailActivityComponent {
  readonly editedAt = input<Date | string | null | undefined>();
  readonly editedBy = input<string | null | undefined>();
  readonly createdAt = input<Date | string | null | undefined>();
  readonly createdBy = input<string | null | undefined>();
}
